const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
}[character]));

const lengthClass = (name) => {
    let length = Array.from(name).length;

    if (length > 32) {
        return 'very-long';
    }

    return length > 18 ? 'long' : 'regular';
};

const wordClass = (name) => {
    let longestWord = String(name).split(/\s+/u).reduce(
        (longest, word) => Math.max(longest, Array.from(word).length),
        0
    );

    return longestWord > 12 ? 'long-word' : 'regular-word';
};

/**
 * @param {string} src
 * @param {string} name
 * @param {boolean} placeholder
 * @param {number} width
 * @param {number} height
 * @param {'small'|'medium'|'large'} size
 * @param {string} alt
 * @param {string} title
 * @param {boolean} loading
 */
const formatShopLogo = ({
    src,
    name,
    placeholder,
    width,
    height,
    size = 'medium',
    alt = '',
    title = '',
    loading = false,
}) => {
    if (!placeholder) {
        return `<img width="${width}" height="${height}" src="${escapeHtml(src)}"` +
            `${loading ? ' loading="lazy"' : ''} alt="${escapeHtml(alt)}"` +
            `${title ? ` title="${escapeHtml(title)}"` : ''}>`;
    }

    let safeName = escapeHtml(name);

    return `<span class="shop-logo-placeholder shop-logo-placeholder--${size} ` +
        `shop-logo-placeholder--${lengthClass(name)} shop-logo-placeholder--${wordClass(name)}" ` +
        `style="--shop-logo-width:${width}px;--shop-logo-ratio:${width}/${height}" ` +
        `role="img" aria-label="${safeName}" title="${safeName}">` +
        `<span class="shop-logo-placeholder__name">${safeName}</span></span>`;
};

export {formatShopLogo};
